import twitter from '~img/twitter.svg'
import youtube from '~img/icons/youtube.svg'
import instagram from '~img/icons/instagram.svg'
import play from '~img/icons/play.svg'

export const getIcon = (icon) => {
  switch (icon) {
    case 'twitter':
      return twitter
    case 'youtube':
      return youtube
    case 'play':
      return play
    default:
      return instagram
  }
}
